import { render, staticRenderFns } from "./HoldingCalculationFeedback.vue?vue&type=template&id=2fe909cc&"
import script from "./HoldingCalculationFeedback.vue?vue&type=script&lang=js&"
export * from "./HoldingCalculationFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports